import { BookKey } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const BookKeyIcon = createLucideIcon(BookKey);
